import moment from "moment";
export default class HelperTool {
  public static url: string;
  public static AIKey: string;

  // tslint:disable-next-line:no-any
  static getCurrentUserId(session: any) {
    return session.get("currentUserId");
  }

  // tslint:disable-next-line:no-any
  static getUsername(session: any) {
    return session.get("username");
  }

  // tslint:disable-next-line:no-any
  static getValue(param: any, defaultValue: any = "") {
    return param ? param : defaultValue;
  }

  static isDev() {
    return process.env.NODE_ENV === "development";
  }
}

export const formatDate = (date: Date) => {
  moment.locale("sv");
  return moment(date).format("L");
};

export const formatCurrency = (
  value: number | undefined,
  currency: string | undefined
) => {
  if (value === undefined) return "";
  if (!currency || currency === "") {
    currency = "USD";
  }

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  let formatted = formatter.format(value);

  // Replace commas with spaces for thousand separators
  formatted = formatted.replace(/,/g, " ");

  return formatted;
};

export const formatAmount = (value: number | undefined) => {
  if (value === undefined) return "";
  return new Intl.NumberFormat("en-US", {
    useGrouping: true,
    minimumFractionDigits: 0,
    maximumFractionDigits: 20,
  })
    .format(value)
    .replace(/,/g, " ");
};
